import React from "react";

import {
  getBentoItemStyle,
  statOuterElement,
} from "~components/BentoGridStats/styles.css";
import { Box } from "~components/Box";

import {
  GridStatsItem,
  type GridStatsItemProps,
} from "~sections/GridStats/_GridStatsItem";

import type { BoxProps } from "~components/Box";
import type { VariantBackgroundColorEnum } from "~styles/common/variant.backgroundColor.css";

type DesktopColumnSize = "1" | "2" | "3" | "4";
type MobileColumnSize = "1" | "2";

export interface BentoItemProps extends Omit<BoxProps, "content"> {
  content: GridStatsItemProps[];
  desktopColumnSize: DesktopColumnSize;
  tabletColumnSize: MobileColumnSize;
  mobileColumnSize: MobileColumnSize;
  background: VariantBackgroundColorEnum;
}

export function BentoStatItem({
  content,
  desktopColumnSize,
  tabletColumnSize,
  mobileColumnSize,
  background,
  ...rest
}: BentoItemProps) {
  return (
    <Box
      {...rest}
      className={getBentoItemStyle({
        desktop: desktopColumnSize,
        tablet: tabletColumnSize,
        mobile: mobileColumnSize,
      })}
    >
      {Array.isArray(content) &&
        content.map((blok) => {
          return (
            <GridStatsItem
              {...blok}
              key={blok._uid}
              outerClassName={statOuterElement}
              background={background}
            />
          );
        })}
    </Box>
  );
}
